<template lang="pug">
  div.cashback-banner-container
    .cashback-banner-title
      HighlightText(v-if="title" :text="title")
    .cashback-banner-list
      .cashback-banner-item(
        v-for="(item, index) in list"
        @click="handleBannerClick(item, index)"
      )
        img.banner-img(:src="item.imgUrl" alt="")
</template>

<script>
import HighlightText from '@/components/highlight-text';
import SPM from '../common/spm';

export default {
  name: 'CashbackBanner',
  components: {
    HighlightText,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.handleBannerExpose();
  },
  methods: {
    // banner点击
    handleBannerClick(item, index) {
      this.$emit('bannerClick', item, index);
      // 投放banner点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_banner',
        businessInfo: {
          banner_actId: item.actId,
          banner_channel: item.channel,
          rankNum: index + 1,
        },
      });
    },
    // 投放banner曝光埋点
    handleBannerExpose() {
      if (this.list && this.list.length > 0) {
        this.list.forEach((item, index) => {
          SPM.moduleExpose({
            moduleId: 'Welfare_onlineretailers_banner',
            contentId: 'Welfare_onlineretailers_banner',
            businessInfo: {
              banner_actId: item.actId,
              banner_channel: item.channel,
              rankNum: index + 1,
            },
          });
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-banner-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 0.06rem;
  width: 100%;
  background-image:
    linear-gradient(
      175.37deg,
      #fff3ca 3.81%,
      #fffbec 25.45%,
      #fff 48.04%,
      #fff 96.4%
    );
  border-radius: 0.16rem;
  box-sizing: border-box;

  .cashback-banner-title {
    height: 0.43rem;
    padding: 0.12rem 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    box-sizing: border-box;
  }

  .cashback-banner-list {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .cashback-banner-item {
      flex: 1;
      margin-right: 0.05rem;

      &:last-child {
        margin-right: 0;
      }

      .banner-img {
        width: 100%;
        vertical-align: bottom;
      }
    }
  }
}
</style>
